/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 13:47:31
 * @LastEditTime: 2022-05-06 14:56:05
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/CommunicationTemplateDetail/config.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  CommunicationCategory,
  TemplateCondition,
} from '@/src/types/common/template';
import { calculateCommunication } from '../tool';

export const breadcrumbData = (
  gateway,
  channelType,
  communicationUuid,
  { getI18n },
  templateName?,
) => {
  const gatewayName = calculateCommunication(gateway, channelType, {
    getI18n,
  }).gateway;

  return [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/settings',
      name: getI18n('general.sider.settings'),
    },
    {
      url: '/settings/communicationList',
      name: getI18n('general.sider.communication'),
    },
    {
      url: `/settings/communicationDetail/${gateway}/${channelType}/${communicationUuid}`,
      name: gatewayName,
    },
    {
      url: '',
      name:
        templateName || getI18n('storeCommunicationSetting.detail.addTemplate'),
    },
  ];
};

export const templateCategoryList = [
  {
    label: getI18nFromGeneral('general.storeCommunicationSetting.order'),
    key: 'Order',
    children: [
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.orderstatusupdate',
        ),
        value: CommunicationCategory.OrderStatus,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.orderpaymentreminder',
        ),
        value: CommunicationCategory.PaymentReminder,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.abandonedshoppingcartreminde',
        ),
        value: CommunicationCategory.AbandonedShoppingCart,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.refundstatusupdate',
        ),
        value: CommunicationCategory.RefundStatus,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.returnstatusupdate',
        ),
        value: CommunicationCategory.ReturnStatus,
      },
      // {
      //   label: getI18nFromGeneral(
      //     'general.storeCommunicationSetting.createsubscriptionbuyorder',
      //   ),
      //   value: CommunicationCategory.CreateSubscriptionBuyOrder,
      // },
      // {
      //   label: getI18nFromGeneral(
      //     'general.storeCommunicationSetting.orderInvoice',
      //   ),
      //   value: CommunicationCategory.OrderInvoice,
      // },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.createorder',
        ),
        value: CommunicationCategory.CreateOrder,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.createshoppingcart',
        ),
        value: CommunicationCategory.CreateShoppingCart,
      },
    ],
  },
  {
    label: getI18nFromGeneral('general.storeCommunicationSetting.fulfillment'),
    key: 'Fulfillment',
    children: [
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.virtualproductservicenotification',
        ),
        value: CommunicationCategory.VirtualProductNotification,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.giftcardissued',
        ),
        value: CommunicationCategory.GiftCardIssued,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.giftcardstorecreditbalancechange',
        ),
        value: CommunicationCategory.GiftCardBalanceChanged,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.storecreditissued',
        ),
        value: CommunicationCategory.StoreCreditIssued,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.logisticsstatusupdate',
        ),
        value: CommunicationCategory.LogisticsStatusUpdate,
      },
    ],
  },
  {
    label: getI18nFromGeneral('general.customer.customer'),
    key: 'Customer',
    children: [
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.customeraccountinvitation',
        ),
        value: CommunicationCategory.AccountInvitation,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.customeraccountwelcome',
        ),
        value: CommunicationCategory.AccountWelcome,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.customeraccountpasswordreset',
        ),
        value: CommunicationCategory.AccountPasswordReset,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.verificationCode',
        ),
        value: CommunicationCategory.VerificationCode,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.customerservicerequest',
        ),
        value: CommunicationCategory.CustomerServiceRequest,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.newVoucherIssued',
        ),
        value: CommunicationCategory.VoucherIssued,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.voucherExpiration',
        ),
        value: CommunicationCategory.VoucherExpiration,
      },
    ],
  },
  {
    label: getI18nFromGeneral('general.storeCommunicationSetting.product'),
    key: 'Product',
    children: [
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.restockitem',
        ),
        value: CommunicationCategory.RestockItem,
      },
      {
        label: getI18nFromGeneral(
          'general.storeCommunicationSetting.flashsalestart',
        ),
        value: CommunicationCategory.FlashSaleStart,
      },
    ],
  },
];

// Promotional template categories that require the unsubscribe tag
export const promotionalCategories = [
  CommunicationCategory.PaymentReminder,
  CommunicationCategory.AbandonedShoppingCart,
  CommunicationCategory.CreateShoppingCart,
  CommunicationCategory.VoucherExpiration,
  CommunicationCategory.VoucherIssued,
];

export const UNSUBSCRIBE_REQUIRED_TAG = '<%asm_group_unsubscribe_raw_url%>';

export const conditions = {
  [TemplateCondition.OrderConfirmed]: getI18nFromGeneral(
    'general.storeCommunicationSetting.orderconfirmed',
  ),
  [TemplateCondition.OrderCancelled]: getI18nFromGeneral(
    'general.storeCommunicationSetting.ordercancelled',
  ),
  [TemplateCondition.RefundRejected]: getI18nFromGeneral(
    'general.storeCommunicationSetting.refundrequestrejected',
  ),
  [TemplateCondition.Refunded]: getI18nFromGeneral(
    'general.storeCommunicationSetting.refunded',
  ),
  [TemplateCondition.ReturnApproved]: getI18nFromGeneral(
    'general.storeCommunicationSetting.returnrequestapproved',
  ),
  [TemplateCondition.ReturnRejected]: getI18nFromGeneral(
    'general.storeCommunicationSetting.returnrequestrejected',
  ),
  [TemplateCondition.ParcelDelivering]: getI18nFromGeneral(
    'general.storeCommunicationSetting.delivering',
  ),
  [TemplateCondition.ParcelDelivered]: getI18nFromGeneral(
    'general.storeCommunicationSetting.delivered',
  ),
  [TemplateCondition.ReadyToCollect]: getI18nFromGeneral(
    'general.storeCommunicationSetting.readytocollectClick&collect',
  ),
  [TemplateCondition.ParcelCollected]: getI18nFromGeneral(
    'general.storeCommunicationSetting.collected',
  ),
};
